import { TLanguage, badgeUrls } from '@geovelo-frontends/commons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import environment from '../../environment';
import useTracker from '../../hooks/tracker';

export function AppStoreBadge({
  height,
  context,
}: {
  context: string;
  height: number;
}): React.JSX.Element {
  const {
    t,
    i18n: { language: currentLanguage },
  } = useTranslation();
  const { trackEvent } = useTracker();

  return (
    <Wrapper
      height={height}
      href={`${environment.ios.storeUrls[currentLanguage]}&pt=413079&mt=8&ct=website`}
      onClick={() => trackEvent('App Store Button Clicked', { context })}
      rel="noreferrer"
      target="_blank"
    >
      <img
        alt={t('commons.app_badge_labels.app_store') || ''}
        src={badgeUrls[currentLanguage as TLanguage].ios}
      />
    </Wrapper>
  );
}

const Wrapper = styled.a<{ height: number }>`
  align-items: center;
  display: flex;
  height: ${({ height }) => `${height}px`};
  overflow: hidden;

  img {
    height: ${({ height }) => `${height}px`};
  }
`;
